import { makeApiRequests } from '../../../helpers/api';

export async function academyGet(endpoint, signal) {
  const controller = new AbortController();
  let timedOut = false;
  const abort = () => controller.abort();
  if (signal) {
    signal.addEventListener('abort', abort);
    if (signal.aborted) abort();
  }
  const timer = setTimeout(() => { timedOut = true; controller.abort(); }, 20000);
  try {
    const result = await makeApiRequests({ endpoint, method: 'GET', signal: controller.signal });
    return timedOut ? { error: 'This is taking longer than expected. Check your connection and try again.' } : result;
  } catch (_) {
    return { error: 'Could not load training. Check your connection and try again.' };
  } finally {
    clearTimeout(timer);
    if (signal) signal.removeEventListener('abort', abort);
  }
}
